module.exports = __webpack_public_path__ + "img/Invasion-OSCC_GSE208253.7ad433a1.png";